import React from "react";
import { Link } from "react-router-dom";
import greenCheck from "../Assets/green-check.png";
import logo from "../../components/Assets/logo.png";

// Static projection component
const StaticProjection = ({ width = 200, top = "0%", showBorder = false }) => {
  return (
    <div
      className="absolute  h-[90px] opacity-80 rounded-full"
      style={{
        width: `${width}px`,
        transform: `translateX(-${width / 2}px) rotate(18deg)`,
        top,
        left: 0,
        backgroundColor: "#0041C2",
        border: showBorder ? "8px solid #87ceeb" : "none",
      }}
    />
  );
};

// Blue projections container
const BlueProjections = () => {
  const projections = [
    { width: 650, top: "0%", showBorder: false },
    { width: 950, top: "25%", showBorder: true },
    { width: 300, top: "50%", showBorder: true },
    { width: 520, top: "75%", showBorder: false },
  ];

  return (
    <div className="absolute top-0 left-0  h-full w-full overflow-hidden z-0 pointer-events-none">
      {projections.map(({ width, top, showBorder }, i) => (
        <StaticProjection
          key={i}
          width={width}
          top={top}
          showBorder={showBorder}
        />
      ))}
    </div>
  );
};

const LogoutPage = () => {
  React.useEffect(() => {
    localStorage.removeItem("authToken");
  }, []);

  return (
    <div className="min-h-screen w-full bg-white relative overflow-hidden">
      {/* Static Blue Projections */}
      <BlueProjections />

      <div className="min-h-screen flex flex-col items-center justify-center px-8 relative z-10 space-y-6">
        <h1 className="text-4xl flex text-center font-sans mb-0 font-semibold">
          <span className="text-black">IRIDIS </span>
          <span className="text-[#0041C2] ml-2"> AMS</span>
        </h1>

        {/* Centered Logout Container  */}
        <div className="w-full max-w-2xl h-auto rounded-2xl bg-white border border-gray-300 px-16 py-12 relative">
          {/* Logout Content */}
          <div className="max-w-sm mt-10 mb-10 mx-auto text-center">
            {/* Green Check Icon */}
            <div className="mb-8 flex justify-center">
              <img
                src={greenCheck}
                alt="Green Checkmark"
                className="w-20 h-20 object-contain"
              />
            </div>

            {/* Success Message */}
            <div className="mb-8">
              <p className="text-gray-800 text-2xl font-medium mb-2">
                Logout Successful!
              </p>
              <p className="text-gray-600 text-base">
                You have successfully logged out
              </p>
            </div>

            {/* Login Link */}
            <Link
              to="/"
              className="inline-block w-full py-3 px-6 bg-blue-600 hover:bg-blue-700 text-white font-medium text-sm rounded-lg transition duration-200 text-center"
            >
              Login?
            </Link>
          </div>
          {/* Logo with label */}
          <div className="absolute bottom-2 left-4 flex items-center space-x-3">
            <img src={logo} alt="Logo" className="w-16 h-auto" />
            <div className="text-sm text-gray-500 font-light leading-snug">
              Asset Management System
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutPage;
